module.exports = __webpack_public_path__ + "img/xny.be120d9.png";